<template>
  <label :class="selector"
         class="checkbox">
    <input type="checkbox"
           :checked="checked"
           @click="onInput">
    <span class="checkbox__mark">
    </span>
    <slot :label="label" :$attrs="$attrs">
      <span v-if="label" class="checkbox__text">
        <span v-if="isAttributeTrue($attrs.required)" class="input__required">*</span>
        {{ label }}
      </span>
    </slot>
  </label>
</template>

<script>
  export default {
    model: {
      prop: 'checked'
    },
    props: {
      checked: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      }
    },
    data() {
      return {}
    },
    computed: {
      selector() {
        let selector = ''
        if (this.checked) selector = selector + ' _checked '
        return selector
      },
    },
    methods: {
      onInput(event) {
        this.$emit('input', event.target.checked)
      },
      isAttributeTrue(attr) {
        return attr || attr === ''
      }
    }
  }
</script>

<style lang="less">

</style>
